import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { FinantialExpensesReportService } from "src/app/shared/services/finantial-expenses-report.service";
import { finantialExpensesReportActions } from "./finantial-expenses-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class FinantialExpensesReportEffects {

    constructor(
        private service: FinantialExpensesReportService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    loadFinantialExpensesReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(finantialExpensesReportActions.loadFinantialExpensesReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => finantialExpensesReportActions.loadFinantialExpensesReportSuccess({ finantial_expenses_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )
            )
        )
    )

}